<template>
    <div
        :data-component="$options.name"
        class="relative mb-16 screen-m:mb-24 border border-solid rounded-10 border-wildsand shadow hover:shadow-hover"
    >
        <a
            class="flex flex-col screen-m:flex-row screen-m:p-16"
            target="_blank"
            rel="noopener"
            aria-label="Go to estate"
            :href="item.detailUrl || ''"
            @click="onClickItem"
        >
            <div
                class="flex relative shrink-0 justify-center items-center w-full h-[277px] screen-m:w-[342px] screen-m:h-[249px] bg-color-brand-beige-50 screen-m:mr-16 rounded-t-10 screen-m:rounded-10"
            >
                <img
                    v-if="item.smallImageUrl"
                    class="object-center object-cover w-full h-full rounded-t-10 screen-m:rounded-10"
                    :src="item.smallImageUrl"
                    :alt="item.title"
                />
                <ms-fallback-svg
                    v-else
                    class="w-80 h-80"
                />
                <div
                    v-if="item.smallImageUrl && item.imageCount"
                    class="absolute flex items-center justify-center text-white rounded right-8 bottom-8 bg-black text-caption bg-opacity-50 screen-m:text-text-desktop pl-4 pr-8"
                    data-test-id="imageCount"
                >
                    <ms-image class="w-[22px] h-[22px] mr-4" />
                    {{ badgeText }}
                </div>
            </div>
            <div class="flex flex-col grow p-16 screen-m:p-0 overflow-hidden justify-between">
                <div
                    class="flex flex-col screen-m:mr-[36px] text-caption-mobile screen-m:text-text-desktop overflow-hidden"
                >
                    <div class="inline-flex h-24 mb-4">
                        <cs-tag
                            v-if="item.newestEstate"
                            data-test-id="newTag"
                            type="highlight"
                            class="mr-8"
                            >Neu</cs-tag
                        >
                        <ms-headline
                            type="h4"
                            :isSpan="true"
                            class="truncate"
                        >
                            {{ item.title }}
                        </ms-headline>
                    </div>
                    <span class="mb-16 text-text truncate">{{ item.address }}</span>
                    <ms-dynamic-tags
                        :tags="equipmentArray"
                        :maxRows="2"
                        class="mb-24"
                    />
                </div>
                <div>
                    <div class="flex flex-wrap mb-16 gap-x-24 gap-y-8 text-text-l">
                        <div
                            v-if="item.livingArea"
                            class="flex"
                        >
                            <ms-floor-plan class="w-24 h-24 mr-8" />
                            <p class="content-center">{{ item.livingArea }} m²</p>
                        </div>
                        <div
                            v-if="item.rooms"
                            class="flex"
                        >
                            <ms-door class="w-24 h-24 mr-8" />
                            <p class="content-center">{{ item.rooms }} Zimmer</p>
                        </div>
                        <div
                            v-if="item.landArea && showLandArea()"
                            class="flex"
                        >
                            <ms-surface class="w-24 h-24 mr-8" />
                            <p class="content-center">{{ item.landArea }} m²</p>
                        </div>
                    </div>
                    <hr class="mb-16" />
                    <div class="flex justify-between items-center">
                        <cs-tag
                            v-if="item.ownInventory"
                            class="w-fit"
                            colorClass="bg-color-signatur-immo-100"
                            data-test-id="offerTypeTag"
                            >{{ getOfferType() }} Angebot</cs-tag
                        >
                        <ms-immowelt-badge v-else />
                        <div class="flex flex-col text-right">
                            <span class="text-text-l font-bold">{{ item.price }}</span>
                            <span class="text-caption text-color-neutral-grey-60">{{ item.priceAppendix }}</span>
                        </div>
                    </div>
                </div>
            </div>
        </a>
        <div class="absolute top-0 right-0">
            <ms-like-button
                :decoratedEstate="item"
                :componentId="parentComponent"
                :isVerticalDesign="!isScreenM"
            />
        </div>
    </div>
</template>

<script lang="ts" src="./MsResultListItem.ts" />
